export default __webpack_public_path__ + "static/media/personal_branding.3a3448ca.svg";